import { HTMLAttributes } from "react";
import { Button, ButtonProps } from "../button";
import { cn } from "../../lib/utils";

interface TimelineBarAction extends Omit<ButtonProps, "variant" | "size"> {
  label: string;
  onClick: () => void;
}

export interface TimelineBarProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtext?: string;
  primaryAction: TimelineBarAction;
  secondaryActions?: TimelineBarAction[];
}

export const TimelineBar = ({
  title,
  subtext,
  primaryAction,
  secondaryActions,
  className,
  ...rest
}: TimelineBarProps) => {
  const showText = !!title || !!subtext;

  return (
    <div
      className={cn(
        `fixed bottom-4 left-4 right-4 bg-white border border-gray-200 px-6 py-4 z-[9999] shadow-2xl rounded-lg`,
        className
      )}
      {...rest}
    >
      <div className={`flex items-center max-w-full ${showText ? "justify-between" : "justify-end"}`}>
        {showText && (
          <div className="flex items-center space-x-3 flex-1 min-w-0">
            <div className="text-sm font-medium text-gray-900">{title}</div>
            <div className="text-sm text-gray-500 truncate">{subtext}</div>
          </div>
        )}

        <div className="flex items-center space-x-2 flex-shrink-0">
          {secondaryActions?.map((action, i) => {
            const { label, ...buttonProps } = action;
            return (
              <Button key={`${label}-${i}`} variant="outline" {...buttonProps}>
                {label}
              </Button>
            );
          })}
          <Button size="sm" {...primaryAction}>
            {primaryAction.label}
          </Button>
        </div>
      </div>
    </div>
  );
};
